const CONTAINERS =
  ".cf-element, .cf-section, .cf-column, .cf-flex-column, .cf-cta-item-container, .canvas[data-step-id]";

export const intersectRects = (first, second) => {
  const left = Math.max(first.left, second.left);
  const top = Math.max(first.top, second.top);
  const right = Math.min(first.left + first.width, second.left + second.width);
  const bottom = Math.min(first.top + first.height, second.top + second.height);
  return right > left && bottom > top
    ? { left, top, width: right - left, height: bottom - top }
    : null;
};

export const canvasOverlayAncestors = (target) => {
  const ancestors = [];
  for (
    let node = target?.parentElement;
    node && node.id !== "builder";
    node = node.parentElement
  ) {
    const style = getComputedStyle(node);
    if (
      node.matches(CONTAINERS) ||
      /(hidden|clip|scroll|auto)/.test(
        `${style.overflow} ${style.overflowX} ${style.overflowY}`
      )
    ) {
      ancestors.push(node);
    }
  }
  return ancestors;
};

export const measureCanvasOverlays = (targets, boundaries) => {
  const rects = new Map();
  const rectOf = (node) => {
    if (!rects.has(node)) rects.set(node, node.getBoundingClientRect());
    return rects.get(node);
  };
  let viewport = {
    top: 0,
    left: 0,
    width: window.innerWidth,
    height: window.innerHeight,
  };
  for (const boundary of boundaries) {
    const rect = rectOf(boundary);
    if (!rect.width || !rect.height) continue;
    const edge = boundary.getAttribute("data-canvas-boundary");
    const right = viewport.left + viewport.width;
    const bottom = viewport.top + viewport.height;
    if (edge === "left")
      viewport.left = Math.max(viewport.left, rect.left + rect.width);
    if (edge === "top")
      viewport.top = Math.max(viewport.top, rect.top + rect.height);
    viewport.width = Math.max(
      0,
      (edge === "right" ? Math.min(right, rect.left) : right) - viewport.left
    );
    viewport.height = Math.max(
      0,
      (edge === "bottom" ? Math.min(bottom, rect.top) : bottom) - viewport.top
    );
  }
  const outlines = targets.map(({ target, ancestors }) => {
    if (!target?.isConnected) return null;
    let rect = intersectRects(rectOf(target), viewport);
    for (const ancestor of ancestors) {
      if (!rect) break;
      rect = intersectRects(rect, rectOf(ancestor));
    }
    return rect;
  });
  return { viewport, outlines };
};

export const canvasLabelPosition = (rect, viewport, width, height) => {
  if (!rect || !width || !height || width > viewport.width) return null;
  const left = Math.min(
    Math.max(rect.left, viewport.left),
    viewport.left + viewport.width - width
  );
  const top = Math.min(
    Math.max(rect.top, viewport.top),
    viewport.top + viewport.height - height
  );
  return { left, top };
};
